@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.usecase.template

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateModel
import com.wintermar.inspection.feature.domain.model.template.TemplateModel
import com.wintermar.inspection.feature.domain.repository.TemplateRepository
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.flowOn

actual class GetTemplateByIdUseCaseImpl actual constructor(val templateRepository: TemplateRepository) :
    GetTemplateByIdUseCase {
    actual override operator fun invoke(
        id: String,
        data: TemplateModel
    ): Flow<FlowResult<InspectionTemplateModel>> {
        return flow {
            emit(FlowResult.Loading(showLoading = true))
            try {
                val result = data.data.find { it.id == id }
                emit(FlowResult.Success(result))
            } catch (e: Exception) {
                emit(FlowResult.Error(e))
            }
            emit(FlowResult.Loading(showLoading = false))
        }.flowOn(Dispatchers.Default)
    }
}
